import { render } from "./success.vue?vue&type=template&id=127b62c0&scoped=true"
import script from "./success.vue?vue&type=script&lang=ts"
export * from "./success.vue?vue&type=script&lang=ts"

import "./success.vue?vue&type=style&index=0&id=127b62c0&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-127b62c0"

export default script